var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMyclassOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E4EFF0",
  d: "M2.84 0h18.338c1.01 0 1.831.82 1.831 1.831v12.867c0 1.01-.82 1.831-1.83 1.831H2.83c-1.01 0-1.831-.82-1.831-1.831V1.841C1 .831 1.82 0 2.84 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B6D0D2",
  d: "M16.807 15.418c0 .62-.4 1.12-.9 1.12H8.103c-.5 0-.9-.5-.9-1.12s-.4-1.121-.9-1.121H1c-.55 0-1 .56-1 1.24v3.222C0 19.45.45 20 1 20h22c.55 0 1-.56 1-1.24v-3.222c0-.69-.45-1.241-1-1.241h-5.303c-.5 0-.9.5-.9 1.12zM17.656 6.534h-7.513c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h7.513c.5 0 .9.4.9.9s-.4.9-.9.9M17.656 10.636h-7.513c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h7.513c.5 0 .9.4.9.9s-.4.9-.9.9M7.251 5.604a.9.9 0 1 0-1.8 0v4.142a.9.9 0 1 0 1.8 0z"
})));
export default SvgIcMyclassOff;